import React from 'react';
import { Section } from './ui/Section';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <Section background="light" data-id="element-145">
      <div className="max-w-2xl mx-auto" data-id="element-146">
        <div className="text-center mb-10" data-id="element-147">
          <span className="text-indigo-600 font-semibold tracking-wider text-sm uppercase" data-id="element-148">
            El problema real
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-slate-900 mt-2" data-id="element-149">
            La mayoría cree que su problema es “dormirse”.
          </h2>
        </div>

        <div className="space-y-6 text-lg text-slate-700 leading-relaxed" data-id="element-150">
          <p data-id="element-151">
            Pero muchas mujeres 40+ se duermen… y lo que se rompe es la{' '}
            <strong data-id="element-152">continuidad</strong>.
          </p>

          <p data-id="element-153">
            Tu cuerpo se despierta más fácil. Y tu mente, a esa hora, no se
            comporta como en la tarde.
          </p>

          <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-154">
            <div className="flex items-start gap-4" data-id="element-155">
              <AlertCircle className="w-6 h-6 text-amber-500 flex-shrink-0 mt-1" data-id="element-156" />
              <div data-id="element-157">
                <h3 className="font-bold text-slate-900 text-lg mb-2" data-id="element-158">
                  A las 3am, tu mente no analiza: controla.
                </h3>
                <p className="text-slate-600" data-id="element-159">
                  Quiere revisar. Quiere resolver. Quiere anticipar. Porque
                  siente que si no controla, algo malo va a pasar mañana. Y así
                  se arma la guerra interna.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}